
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fulfillment-services",
      function () {
        return require("private-next-pages/fulfillment-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fulfillment-services"])
      });
    }
  